import { render, staticRenderFns } from "./appDashboard.vue?vue&type=template&id=307d81f4&scoped=true"
import script from "./appDashboard.vue?vue&type=script&lang=js"
export * from "./appDashboard.vue?vue&type=script&lang=js"
import style0 from "./appDashboard.vue?vue&type=style&index=0&id=307d81f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307d81f4",
  null
  
)

export default component.exports